import React from "react";
import { NavLink } from "react-router-dom";
import { Shield, Trophy } from "lucide-react";

const TABS = [
  { to: "/admin/teams", label: "Teams", icon: Shield, testid: "nation-nav-teams" },
  { to: "/admin/tournaments", label: "Tournaments", icon: Trophy, testid: "nation-nav-tournaments" },
];

export default function NationNav() {
  return (
    <div className="flex gap-1 border-b border-slate-200 mt-6 mb-6">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          data-testid={t.testid}
          className={({ isActive }) =>
            `inline-flex items-center gap-2 px-4 py-3 text-xs font-semibold uppercase tracking-wider border-b-2 ${
              isActive ? "border-[#E63946] text-[#0A192F]" : "border-transparent text-slate-500 hover:text-slate-800"
            }`
          }
        >
          <t.icon className="w-4 h-4" /> {t.label}
        </NavLink>
      ))}
    </div>
  );
}
